exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".m-dropdown-menu-wrapper{position:relative;display:inline-block;width:100%}.m-dropdown-menu-wrapper .m-dropdown{position:absolute;width:inherit;background-color:#fff;z-index:10}.m-dropdown-menu-wrapper .m-dropdown.is-bottom{top:100%}.m-dropdown-menu-wrapper .m-dropdown.is-top{bottom:100%}", ""]);

// exports
